module.exports = __webpack_public_path__ + "media/images/avatar1-ad1d1038f2980a61a4ae07c5a6c3a133.jpg";